import { Map } from 'immutable';
import { utils, constants } from '@saucelabs/sl-module-activity';

import * as types from './types';

const { serializeMultiActivityData } = utils;
const { CHARTS_NUMBER_OF_PERIODS } = constants;

const initialState = Map({
  loadingUsersActivity: false,
  loading: false,
  activity: Map(),
});

const getDateRange = (payload) => {
  const includeStartDay = payload.dateFilterType === 'absolute';
  return utils.getDateRange(payload) + (includeStartDay ? 1 : 0);
};

const activityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_USERS_ACTIVITY_COMPLETE:
      return state.set('loadingUsersActivity', false);
    case types.GET_USER_ACTIVITY.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('loadingUsersActivity', true)
          .set('activity', Map());
      });
    case types.GET_USER_ACTIVITY.SUCCESS:
      return state.withMutations((newState) => {
        const daterange = getDateRange(payload);
        const data = serializeMultiActivityData(
          payload, daterange, CHARTS_NUMBER_OF_PERIODS,
        );
        newState.setIn(['activity', payload.username], data);
      });
    case types.GET_ORGANIZATION_ACTIVITY.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('loading', true)
          .set('activity', Map());
      });
    case types.GET_ORGANIZATION_ACTIVITY.SUCCESS: {
      return state.withMutations((newState) => {
        const daterange = getDateRange(payload);
        const data = serializeMultiActivityData(
          payload, daterange, CHARTS_NUMBER_OF_PERIODS,
        );
        newState.setIn(['activity', payload.orgId], data);
        newState.set('loading', false);
      });
    }
    case types.GET_USER_ACTIVITY.FAILURE:
    case types.GET_ORGANIZATION_ACTIVITY.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('loading', false)
          .set('activity', Map());
      });
    case types.CLEAN_UP:
      return initialState;
    default:
      return state;
  }
};

export default activityReducer;
export { initialState, getDateRange };
